webpackJsonp([118501925879540],{

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-top: 1.5rem;\n\n  text-align: center;\n\n  h3 {\n    margin: 0;\n  }\n\n  p {\n    font-size: 1.3rem;\n  }\n"], ["\n  margin-top: 1.5rem;\n\n  text-align: center;\n\n  h3 {\n    margin: 0;\n  }\n\n  p {\n    font-size: 1.3rem;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"], ["\n  flex: 1;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(62);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _FlexRow = __webpack_require__(63);
	
	var _FlexRow2 = _interopRequireDefault(_FlexRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CenterContent = _styledComponents2.default.div(_templateObject);
	
	var ContactInfo = _styledComponents2.default.div(_templateObject2);
	
	var RsvpPage = function RsvpPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Card2.default,
	      { header: "RSVP" },
	      _react2.default.createElement(
	        CenterContent,
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Please RSVP by Sunday, July 15, 2018"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Call, text, or email to RSVP and include if you will also be attending the rehearsal dinner and/or the Sunday brunch."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Don't forget to visit ",
	          _react2.default.createElement(
	            "a",
	            { href: "/whats-happening" },
	            "What's Happening"
	          ),
	          " ",
	          "for event schedule, locations, and group rate hotel accommodations."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We look forward to celebrating with our family and friends!"
	        ),
	        _react2.default.createElement(
	          _FlexRow2.default,
	          null,
	          _react2.default.createElement(
	            ContactInfo,
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Adam"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "tel:+1-720-289-4505" },
	                "(720) 289-4505"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:adam625@gmail.com" },
	                "adam625@gmail.com"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ContactInfo,
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Casey"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "tel:+1-812-589-9168" },
	                "(812) 589-9168"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:casey.t.lee@gmail.com" },
	                "casey.t.lee@gmail.com"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = RsvpPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rsvp-js-ce40b4980507219291a6.js